checkInputs();
function checkInputs() {
  var $inputs = $('input[type="text"], input[type="email"], input[type="password"], input[type="tel"], textarea');
  $inputs.each(function () {
    $(this).closest(".form-group").toggleClass("focused", !!$(this).val());
  });

  $(document)
    .off("focusin.checkInputs focusout.checkInputs")
    .on("focusin.checkInputs", 'input[type="text"], input[type="email"], input[type="password"], input[type="tel"], textarea', function () {
    $(this).closest(".form-group").addClass("focused");
    })
    .on("focusout.checkInputs", 'input[type="text"], input[type="email"], input[type="password"], input[type="tel"], textarea', function () {
    $(this).closest(".form-group").toggleClass("focused", !!$(this).val());
    });

  $inputs.off("focus.checkInputs blur.checkInputs click.checkInputs");

  $inputs.on("click.checkInputs focus.checkInputs", function () {
    $(this).closest(".form-group").addClass("focused");
  });

  $inputs.on("blur.checkInputs", function () {
    $(this).closest(".form-group").toggleClass("focused", !!$(this).val());
  });
  $("#fullName").closest(".form-group").toggleClass("focused", !!$("#fullName").val());
  $("#name").closest(".form-group").toggleClass("focused", !!$("#fullName").val());
}

$(document).on("cbox_complete", function () {
  checkInputs();
});
